import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { getSectionDescriptions } from '@/services/api/sectionDescriptions';
import type { SectionDescription } from '@/types/sectionDescription';

export function useSectionDescriptions(productId: number | undefined) {
  const { i18n } = useTranslation();
  const language = i18n.language?.split('-')[0] === 'de' ? 'deutsch' : 'english';

  const { data: descriptions } = useQuery({
    queryKey: ['sectionDescriptions', productId, language],
    queryFn: () => getSectionDescriptions(productId!, language),
    enabled: !!productId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const getDescription = useCallback(
    (featureName: string, sectionKey: string): SectionDescription | undefined => {
      if (!descriptions) return undefined;
      const featureLower = featureName.toLowerCase();
      const sectionLower = sectionKey.toLowerCase();
      return descriptions.find(
        (d) =>
          d.featureTemplateName.toLowerCase() === featureLower &&
          d.sectionKey.toLowerCase() === sectionLower
      );
    },
    [descriptions]
  );

  return { getDescription };
}
